import React from 'react';
import LogInForm from './components/AdminResetPassword';
import './login.css';
import { Col, Container, Row } from 'reactstrap';

const AdminResetPassword = () => 
( <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Password Reset : Admin</h3>
      </Col>
    </Row>
   
    <Row style = {{justifyContent: "center"}}>
      <LogInForm />
    </Row>

   
  </Container>
  );

export default AdminResetPassword;
